import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { ImageItem } from './ImageItem';
import { Button } from '@/components/buttons';
import { Text } from '@/components/typography';
import { LINKS } from '@/constants/links';
export function Team() {
  const $ = _c(21);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["aboutUs"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("team.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 lg:mb-6" anchorKey="team.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("team.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="text-center text-gray-800">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="mx-auto max-w-192">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mx-auto my-12 max-w-[23rem] lg:my-16 lg:max-w-292"><div className="grid grid-flow-col grid-cols-2 grid-rows-5 gap-4 lg:grid-cols-6 lg:grid-rows-2 lg:gap-8"><ImageItem src="/images/sections/aboutUs/team/1-1.jpg" width={1} height={1} className="lg:order-1" /><ImageItem src="/images/sections/aboutUs/team/2.jpg" width={2} height={2} className="lg:order-3" /><ImageItem src="/images/sections/aboutUs/team/1-2.jpg" width={1} height={1} className="lg:order-2" /><ImageItem src="/images/sections/aboutUs/team/3-1.jpg" width={2} height={1} className="lg:order-4" /><ImageItem src="/images/sections/aboutUs/team/3-2-1.jpg" width={1} height={1} className="lg:order-5" /><ImageItem src="/images/sections/aboutUs/team/3-2-2.jpg" width={1} height={1} className="lg:order-6" /><ImageItem src="/images/sections/aboutUs/team/4.jpg" width={1} height={2} className="order-7 hidden lg:block" /></div></div>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = LINKS();
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = t7.registration;
  let t9;
  if ($[14] !== t) {
    t9 = t("team.cta");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <Button to={t8} testId="aboutUsRegistration" analyticsParam="aboutUsRegistration" size="lg" variant="primary" align="center">{t9}</Button>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5) {
    t11 = <div className="px-4">{t5}{t6}{t10}</div>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}